module.exports = __webpack_public_path__ + "static/img/company_logo.1769678785359.png";